<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings"></ion-back-button>
    </ion-buttons>

    <ion-title *ngIf="stylist">{{ stylist.firstName + ' ' + stylist.lastName }}</ion-title>

    <!--ion-button slot="end"
      [disabled]="isLoading || errorOccurredWhileLoadingStylistPicker"
      (click)="onStylistFormSave()">
      Done
    </!--ion-button-->
  </ion-toolbar>
</ion-header>

<ion-content>
  <salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>

  <salonmonster-tap-retry
    *ngIf="errorOccurredWhileLoadingStylistPicker"
    (click)="onTapToReload()"
  ></salonmonster-tap-retry>
  <ion-row *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker">
    <ion-col size="12" size-md="3" class="ion-text-center ion-no-padding">
      <div class="stylist-profile-photo">
        <img *ngIf="!isImageLoading" [src]="stylist.getFullPhotoUrl()" />
        <salonmonster-load-mask *ngIf="isImageLoading"></salonmonster-load-mask>
        <div>
          <div *ngIf="!isMobile" (click)="changeProfilePhotoWeb()" tappable>
            <ion-button
              expand="block"
              fill="clear"
              class="ion-margin-top"
              color="dark"
              class="stylist-profile-photo-upload-icon"
            >
              <ion-icon slot="start" name="camera"></ion-icon> Change photo
            </ion-button>

            <input
              type="file"
              #imageUploadInput
              accept="image/jpeg,image/jpg,image/png"
              style="display: none"
              (change)="onImageUploadInputChange($event)"
            />
          </div>
        </div>
      </div>
      <div>
        <ion-button
          expand="block"
          fill="clear"
          class="ion-margin-top"
          color="dark"
          *ngIf="isMobile"
          (click)="onNativeChangePhoto()"
        >
          <ion-icon slot="start" name="camera"></ion-icon> Change Photo
        </ion-button>
      </div>
      <div>
        <ion-button
          expand="block"
          fill="clear"
          class="ion-margin-top"
          color="pale"
          *ngIf="isEditingMyProfile || isUserAdmin"
          (click)="onChangePassword()"
        >
          <ion-icon slot="start" name="key"></ion-icon> Change Password
        </ion-button>
      </div>
      <!--div>
        <ion-button 
          *ngIf="userService.getUser().isAdministrator() && !isEditingMyProfile"
          size="small"
          fill="solid"
          color="danger"
          (click)="onStylistDelete()">
          Delete staff
        </ion-button> 
      </!--div-->
    </ion-col>
    <ion-col>
      <div>
        <ion-segment [(ngModel)]="tab">
          <ion-segment-button value="stylist-details">
            Profile
          </ion-segment-button>
          <ion-segment-button value="stylist-permissions">
            Permissions
          </ion-segment-button>
        </ion-segment>
      </div>

      <form [formGroup]="stylistProfileForm" (ngSubmit)="onStylistFormSave()">
        <div *ngIf="tab == 'stylist-details'">
          <ion-list>
            <ion-item class="ion-text-wrap" lines="none">
              Your email and work phone will be used in client communications.
              All other contact information can only be seen by other staff.
            </ion-item>

            <ion-item-group lines="none">
              <ion-item-divider>
                <ion-icon name="person"></ion-icon>
              </ion-item-divider>
              <ion-item lines="none">
                <ion-label position="stacked">First Name *</ion-label>
                <ion-input
                  type="text"
                  name=""
                  formControlName="firstName"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>

              <ion-item *ngIf="!firstName.valid && submitAttempt" lines="none">
                <p *ngIf="firstName.hasError('required')" class="sm-error">
                  Firstname is required.
                </p>

                <p *ngIf="firstName.hasError('maxlength')" class="sm-error">
                  First Name cannot exceed 30 characters.
                </p>
              </ion-item>

              <ion-item lines="none">
                <ion-label position="stacked">Last Name</ion-label>
                <ion-input
                  type="text"
                  name=""
                  formControlName="lastName"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>

              <ion-item *ngIf="!lastName.valid && submitAttempt" lines="none">
                <p *ngIf="lastName.hasError('maxlength')" class="sm-error">
                  Last Name cannot exceed 35 characters.
                </p>
              </ion-item>

              <ion-item lines="none">
                <ion-label position="stacked">Pronouns</ion-label>
                <ion-select formControlName="pronoun" [interface]="'popover'">
                  <ion-select-option
                    *ngFor="let option of pronounOptions"
                    [value]="option.value"
                  >
                    {{ option.name }}
                  </ion-select-option>
                </ion-select>
              </ion-item>

              <ion-item lines="none" [hidden]="pronouns.value != 4">
                <ion-label position="stacked">Enter Custom Pronouns</ion-label>
                <ion-input
                  type="text"
                  name="customPronoun"
                  formControlName="customPronoun"
                  clearInput
                ></ion-input>
              </ion-item>
              <ion-item *ngIf="!customPronouns.valid && submitAttempt">
                <p
                  *ngIf="customPronouns.hasError('maxlength')"
                  class="sm-error"
                >
                  Custom Pronouns can't exceed 30 letters.
                </p>
              </ion-item>
              <ion-item lines="none">
                <ion-label position="stacked">Title</ion-label>
                <ion-input
                  type="text"
                  name=""
                  placeholder="eg. Hairstylist"
                  formControlName="title"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>
              <ion-item *ngIf="!title.valid && submitAttempt" lines="none">
                <p *ngIf="title.hasError('maxlength')" class="sm-error">
                  Title cannot exceed 35 characters.
                </p>
              </ion-item>
            </ion-item-group>

            <ion-item-group lines="none">
              <ion-item-divider
                ><ion-icon name="book"></ion-icon
              ></ion-item-divider>
              <ion-item lines="none">
                <ion-label position="stacked">Email</ion-label>
                <ion-input
                  type="email"
                  name=""
                  formControlName="email"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>

              <ion-item *ngIf="email.pending" lines="none">
                <ion-spinner icon="crescent" color="primary"></ion-spinner>
                Checking email availability...
              </ion-item>

              <ion-item
                *ngIf="!email.valid && email.hasError('stylistEmailAvailability')"
                lines="none"
              >
                <p class="sm-error">Email already taken.</p>
              </ion-item>

              <ion-item *ngIf="!email.valid && submitAttempt" lines="none">
                <p *ngIf="email.hasError('validateEmail')" class="sm-error">
                  Email is invalid.
                </p>

                <p *ngIf="email.hasError('maxlength')" class="sm-error">
                  Email cannot exceed 100 characters.
                </p>
              </ion-item>

              <ion-item lines="none">
                <ion-label position="stacked">Home phone</ion-label>
                <ion-input
                  type="tel"
                  name=""
                  formControlName="phone1"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>

              <ion-item *ngIf="!phone1.valid && submitAttempt" lines="none">
                <p *ngIf="phone1.hasError('maxlength')" class="sm-error">
                  Home phone cannot exceed 20 characters.
                </p>
                <p *ngIf="phone1.hasError('validatePhone')" class="sm-error">
                  Oops, this phone is invalid.
                </p>
              </ion-item>

              <ion-item lines="none">
                <ion-label position="stacked">Mobile phone</ion-label>
                <ion-input
                  type="tel"
                  name=""
                  formControlName="phone2"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>

              <ion-item *ngIf="!phone2.valid && submitAttempt" lines="none">
                <p *ngIf="phone2.hasError('maxlength')" class="sm-error">
                  Mobile phone cannot exceed 20 characters.
                </p>
                <p *ngIf="phone2.hasError('validatePhone')" class="sm-error">
                  Oops, this phone is invalid.
                </p>
              </ion-item>
            </ion-item-group>

            <ion-item-group lines="none">
              <ion-item-divider
                ><ion-icon name="home"></ion-icon
              ></ion-item-divider>
              <ion-item lines="none">
                <ion-label position="stacked">Address 1</ion-label>
                <ion-input
                  type="text"
                  name=""
                  formControlName="address1"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>

              <ion-item *ngIf="!address1.valid && submitAttempt" lines="none">
                <p *ngIf="address1.hasError('maxlength')" class="sm-error">
                  Address 1 cannot exceed 40 characters.
                </p>
              </ion-item>

              <ion-item lines="none">
                <ion-label position="stacked">Address 2</ion-label>
                <ion-input
                  type="text"
                  name=""
                  formControlName="address2"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>

              <ion-item *ngIf="!address2.valid && submitAttempt" lines="none">
                <p *ngIf="address2.hasError('maxlength')" class="sm-error">
                  Address 2 cannot exceed 40 characters.
                </p>
              </ion-item>

              <ion-item lines="none">
                <ion-label position="stacked">City</ion-label>
                <ion-input
                  type="text"
                  name=""
                  formControlName="city"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>

              <ion-item *ngIf="!city.valid && submitAttempt" lines="none">
                <p *ngIf="city.hasError('maxlength')" class="sm-error">
                  City cannot exceed 20 characters.
                </p>
              </ion-item>

              <ion-item lines="none">
                <ion-label position="stacked">Province</ion-label>
                <ion-input
                  type="text"
                  name=""
                  formControlName="province"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>

              <ion-item *ngIf="!province.valid && submitAttempt" lines="none">
                <p *ngIf="province.hasError('maxlength')" class="sm-error">
                  Province cannot exceed 25 characters.
                </p>
              </ion-item>

              <ion-item lines="none">
                <ion-label position="stacked">Postal</ion-label>
                <ion-input
                  type="text"
                  name=""
                  formControlName="postal"
                  clearInput
                  class="sm-input-border"
                ></ion-input>
              </ion-item>

              <ion-item *ngIf="!postal.valid && submitAttempt">
                <p *ngIf="postal.hasError('maxlength')" class="sm-error">
                  Postal cannot exceed 25 characters.
                </p>
              </ion-item>
              <ion-item lines="none">
                <ion-label>Country *</ion-label>
                <ion-select
                  placeholder="Select a Country"
                  formControlName="country"
                >
                  <ion-select-option
                    *ngFor="let country of countries"
                    [value]="country.getID()"
                  >
                    {{country.getCountryName()}}
                  </ion-select-option>
                </ion-select>
              </ion-item>
              <ion-item *ngIf="!country.valid && submitAttempt" lines="none">
                <p *ngIf="country.hasError('required')" class="sm-error">
                  Country is required.
                </p>
              </ion-item>
            </ion-item-group>
          </ion-list>
          <br />
          <br />
          <br />
        </div>

        <ion-list *ngIf="tab == 'stylist-permissions'">
          <ion-item>
            <ion-label>Active</ion-label>
            <ion-toggle formControlName="active" (ionChange)="onActiveChange()"></ion-toggle>
          </ion-item>
          
          <ion-item>
            <ion-label>Scheduling (has a calendar)</ion-label>
            <ion-toggle [disabled]="active.value == false" formControlName="hasCalendar" (ionChange)="onActiveChange()"></ion-toggle>
          </ion-item>
          <ion-item>
            <ion-label>Administrator</ion-label>
            <ion-toggle (ionChange)="onAdminToggleChange($event)" [disabled]="active.value == false" formControlName="administrator" ></ion-toggle>
          </ion-item>
          <div>
            <ion-item>
              <ion-label>Can edit their own settings</ion-label>
              <ion-toggle formControlName="canEditOwnSettings" [disabled]="administrator.value == true || active.value == false"></ion-toggle>
            </ion-item>
            <ion-item>
              <ion-label>Can view all clients of the salon</ion-label>
              <ion-toggle formControlName="canViewAllClients" [disabled]="administrator.value == true || active.value == false"></ion-toggle>
            </ion-item>
            <ion-item>
              <ion-label>Can view all staff calendars</ion-label>
              <ion-toggle
                formControlName="canViewAllStaffCalendars"
                [disabled]="administrator.value == true || active.value == false"
              ></ion-toggle>
            </ion-item>
            <ion-item>
              <ion-label>Can view their reports</ion-label>
              <ion-toggle formControlName="canViewAllReports" [disabled]="administrator.value == true || active.value == false"></ion-toggle>
            </ion-item>
            <ion-item>
              <ion-label>Can receive push notifications</ion-label>
              <ion-toggle
                formControlName="canReceivePushNotificaitons"
                [disabled]="administrator.value == true || active.value == false"
              ></ion-toggle>
            </ion-item>
          </div>
        </ion-list>
      </form>

      <ion-button
        class="ion-no-margin"
        expand="block"
        fill="clear"
        color="danger"
        *ngIf="!readOnlyStylistPicker && !isEditingMyProfile"
        (click)="onStylistDelete()"
      >
        Delete staff
      </ion-button>

      <!--ion-buttons>
        <ion-button 
          [disabled]="isLoading || errorOccurredWhileLoadingStylistPicker" 
          
          fill="solid"
          color="primary"
          (click)="onStylistFormSave()">
          Save
        </ion-button>
      </!--ion-buttons-->

      <ion-button
        class="hidden-sm-down ion-no-margin"
        expand="block"
        [disabled]="isLoading || errorOccurredWhileLoadingStylistPicker"
        (click)="onStylistFormSave()"
      >
        Save
      </ion-button>
    </ion-col>
  </ion-row>
</ion-content>

<ion-footer
  class="ion-no-padding hidden-md-up"
  *ngIf="!isLoading && !errorOccurredWhileLoadingStylistPicker"
>
  <ion-toolbar class="ion-no-margin ion-no-padding">
    <ion-button
      [disabled]="isLoading || errorOccurredWhileLoadingStylistPicker"
      fill="solid"
      expand="block"
      color="primary"
      (click)="onStylistFormSave()"
    >
      Save
    </ion-button>
  </ion-toolbar>
</ion-footer>
